/**
 * 구독 API 검증 결과 레이어
 */
export default class SubscriptionLayer {
  constructor(type) {
    $('.subscription-layer').remove();

    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_subscriptionLayer';
    this.type = type;
    this.render();
  }

  setEvent = () => {
    this.welContainer.on(
      'click',
      `#${this.sWrapper} .popup_button`,
      this.type === 'OLD_APP' ? this.close : this.landing
    );
  };

  clearEvent = () => {
    this.welContainer.off('click', `#${this.sWrapper} .popup_button`);
  };

  landing = () => {
    if (TMON.view_mode !== 'app') {
      this.close();
      window.location.href = `${TMON.htLocal.htURL.benefit}/goodogplus`;
      return;
    }

    if (
      TMON.app.checkVersion('5.6.6') === null ||
      TMON.app.checkVersion('5.6.6') < 0
    ) {
      this.notifyOldApp();
    } else {
      this.close();
      TMON.app.callApp('webview', 'goSubscriptionService');
    }
  };

  close = () => {
    $(`#${this.sWrapper}`)
      .find('.popup_header_close')
      .trigger('click');
  };

  open = () => {
    this.clearEvent();
    this.setEvent();

    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
        bSetHash: false,
        bUseHistorybackOnClose: false,
        bShowDimmed: true,
      });
    } else {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
      });
    }
  };

  notifyOldApp = () => {
    this.type = 'OLD_APP';
    this.clearEvent();
    this.setEvent();

    $(`#${this.sWrapper}`)
      .find('.popup_header_title')
      .html(this.guideHtml)
      .end()
      .find('.popup_button')
      .text('확인');
  };

  render = () => {
    const guide = this.guideHtml;
    const sHTML = `
              <section id="${this.sWrapper}" class="popup popup_layer popup_marketing subscription-layer">
                  <header class="popup_header">
                      <h3 class="popup_header_title">${guide}</h3>
                      <button type="button" class="popup_header_close" data-role="close" aria-label="팝업닫기">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                              <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                          </svg>
                      </button>
                  </header>
              </section>
          `;

    this.welContainer.append(sHTML);
  };

  get guideHtml() {
    const GUID_HTML = {
      SUBS_CNCL_RESV:
        '구독해지 신청을 하셨습니다.<br>위약금 계산을 위해 딜 구매가 제한됩니다.',
      SUBS_NOT_MEMBER_RESV:
        '해당 상품은 기존 구독 고객만<br>구입하실 수 있습니다. 감사합니다.',
      OLD_APP: '구독 서비스 이용을 위해서<br>앱 업데이트를 진행해 주세요.',
    };
    return GUID_HTML[this.type];
  }
}
